import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Image, Grid, List, Dropdown, Transition, Label, Popup, ListItem, Modal, ModalContent, Checkbox } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../App.js';
import Collapsible from 'react-collapsible';
import { TagColors } from './HomeHelper.js';
import {nounoptions1, nfounoptions2, options1, options2, options3, customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam} from './constants/constants.js'
import * as Scroll from 'react-scroll';
import ReactGA from "react-ga4";
import Recorder from './Recorder.js';
ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;
// let customFontFam = "Roboto,'Helvetica Neue',Arial,Helvetica,sans-serif"

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

let nounOptionsMVPossessorsThe = [
  {id: 1, value: '110', text:'my'},
  {id: 2, value: '210', text:'your'},
  {id: 3, value: '311', text:'his/her'},
  {id: 11, value: '130', text:'our'},
  {id: 12, value: '230', text:"you all's"},
  {id: 13, value: '330', text:'their'},
  {id: 0, value: '000', text:"someone's"},
];

let possessorEnglish = {
	'110':'ax̲',
	'210':'i',
	'311':'du',
	'130':'haa',
	'230':'yee',
	'330':'has du',
	'000':'k̲aa',
}

let nonLinguistic = {
	'imperative':'command',
	'imperative_singular':'command',
	'imperative_plural':'command plural',
	'imperfective_prohibitive':"don't",
	'prohibitive':"don't",
	'prohibitive_singular':"don't",
	'prohibitive_plural':"don't plural",
	'perfective':'completed',
	'perfective_habitual':'every time',
	'progressive_imperfective':'present, in-progress',
	'repetitive_imperfective':'regularly',
	'repetitive_imperfective_negative':"never",
	'repetitive_imperfective_prohibitive':"never",
	'imperfective':'present, not completed',
	'imperfective_habitual':'always',
	'perfective_habitual_negative':'has not yet',
	'potential_attributive':'no way can',
	'conditional':'if/when',
	'hortative':'let',
	'imperfective_attributive':'the one who',
	'imperfective_decessive':'used to',
	'imperfective_decessive_negative':"didn't used to",
	'potential_decessive':'would have',
	'perfective_prohibitive':"didn't",
	'perfective_negative':'completed negative',
	'imperfective_negative':"present negative",


}

let newparadigm = [
    ["progressive_imperfective", 'DNO'],
    ["imperfective", [["@ good","he/she/it","is","",""],"3Sg___",['no4'],{
            "3Sg___": [
                        [
                            ["k̲uyak'éi","g",""],
                            ["k̲uwak'éi","o",".mp3"]
                        ],
                        "it's fine", 
                    ],
            "1Sg___": [
                        [
                            ["x̲at yak'éi","o",".mp3"],
                        ],
                        '=',
                    ],
            "2Sg___": [
                        [
                            ["iyak'éi","g",""],
                        ],
                        '',
                    ],
        }
    ]],
]


const options = [
  { key: 'd', text: 'Dropdown', value: 0 },
  { key: 'e', text: 'Expanded List', value: 1 },
]

let innerWidthSetting = 480

let moodList = [
'imperative',
'prohibitive',
'imperfective_prohibitive',
'repetitive_imperfective_prohibitive',
'imperfective',
'imperfective_negative',
'progressive_imperfective',
'imperfective_attributive',
'imperfective_decessive',
'imperfective_decessive_negative',
'perfective',
'perfective_negative',
'future',
'future_negative',
'hortative',
'imperfective_habitual',
'perfective_habitual',
'perfective_habitual_negative',
'potential_attributive',
'potential_decessive',
'conditional',
'repetitive_imperfective',
'repetitive_imperfective_negative',
]

class Entry extends Component {
	constructor(props) {
		super(props);

    // console.log(decodeURI(props.match.params.word))

		// console.log(props)
		let disableRec = true
    console.log('preloaded disableRecord: '+localStorage.getItem('disableRecord'))
    if (localStorage.getItem('disableRecord') != null) {
      disableRec = (localStorage.getItem('disableRecord') === 'true');
    }      
		this.state = {
			word: decodeURI(props.match.params.word),
			history: props.location.state === undefined ? [] : props.location.state.history,
			from: props.location.state === undefined ? '' : props.location.state.from,
			prevCategory: props.location.state === undefined ? 'all' : ('currentCategory' in props.location.state ? props.location.state.currentCategory:'all'),
			parseIndex:0,

			children:[],
    	lexicon:'',
    	pos:'',
    	varsp:[],
    	gloss:[],
    	soundfile:[],
    	semantic_domain:[],
    	dialect:[],
    	reversal:[],
    	examples:[],
    	Possessed:'',
    	PossTlingit:'',
    	possValue:'311',
    	Verb_Root:'',
    	LeerEdwards_Theme:[],
    	NaishStory_Theme:'',
    	// Conjugation_Prefix:'',
    	// Motion_Verbtype:'',
    	// Valence:'',
    	// Pronoun:'',
    	notes1:[],
    	notes2:[],
    	verb_paradigms:[],
    	verb_paradigms_roots:[],
    	verb_paradigms_processed:{},
    	noun_paradigms:[],
    	adverb_paradigms:[],
			siblings:[],
			homonyms:[],
			properties:[],

    	loaded:false,

    	//ADD MORE
			// future:"_3Sg__",
			// future_negative:"_3Sg__",
			// imperfective:"_3Sg__",
			// imperfective_negative:"_3Sg__",
			// perfective:"_3Sg__",
			// perfective_negative:"_3Sg__",

			moodPOS:[],
			POSCandidateList:[],
			sortValue:0,
			// sortValue:1,

			boldedsubject: true,
			displaypos: true,
      showModal:-1,
      openPopup:-1,
      disableRecord:disableRec,

      playingAudio: false,
      clickedAudioUrl: "",
      clickedAudio: null,
      clickedAudioIndex:-1,

		}
	    // this.getWord = this.getWord.bind(this);
	    // this.getWord(decodeURI(props.match.params.word));
	    scroll.scrollTo(0);
	}

	componentDidMount(){
		// this.getWord(decodeURI(this.props.match.params.word));
    if (decodeURI(this.props.match.params.word) == 'phrasebook') {
      this.props.history.push('/phrasebook/1')            
    } else if (decodeURI(this.props.match.params.word) == 'dialogues') {
      this.props.history.push('/dialogues/1')            
    } else {
    	this.initializeWord()
    }		


	}

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.word !== this.props.match.params.word) {
    	this.initializeWord()
    	scroll.scrollTo(0);
    }
    if (this.state.disableRecord !== prevState.disableRecord) {
    	localStorage.setItem('disableRecord', this.state.disableRecord)
    }
  }


  componentWillReceiveProps(nextProps) {
    // console.log(nextProps)
    this.setState({ 
			from: nextProps.location.pathname,
			// fullDefinition: nextProps.fullDefinition,
		})
	}

	initializeWord() {

	  axios
      .get(API_URL + "/tlingitword/" + decodeURI(this.props.match.params.word))
      .catch(error => {
      	// console.log(error,this.props)
		    return this.props.history.push('/')
		  })
      .then(response => {
        // let end = now();
        // ReactGA.timing({
        //   category: 'Loading',
        //   variable: 'dictionary',
        //   value: (end-start).toFixed(3),
        //   label: 'Dictionary loading'
        // });
        // audiolibrary = response.data;
        // fuse.setCollection(dictionary);
        // fuse1.setCollection(dictionary);
        // console.log(response);
        if (response != undefined) {

	        let entryResults = response.data

	        let moodPOS = []
	        if (entryResults.verb_paradigms_processed != undefined) {
	        	Object.keys(entryResults.verb_paradigms_processed).forEach(entry => {moodPOS.push({'name':entry,'key':entryResults.verb_paradigms_processed[entry][0]})}) // create dictionary_dict dictionary
	        }
	        let properties = []
	        if (entryResults.properties != undefined) {
	        	properties = entryResults.properties
	        }
	        let POSCandidateList = []
	        if (entryResults.SONP != undefined) {
	        	POSCandidateList = this.returnPOSCandidateList(entryResults.SONP, properties)
	        }
	        

			    this.setState({
			    	lexicon:entryResults.lexicon === undefined ? '' : entryResults.lexicon,
			    	pos:entryResults.pos === undefined ? '' : entryResults.pos,
			    	varsp:entryResults.varsp === undefined ? [] : entryResults.varsp,
			    	children:entryResults.children === undefined ? [] : entryResults.children,
			    	dialect:entryResults.dialect === undefined ? [] : entryResults.dialect,
			    	gloss:entryResults.gloss === undefined ? [] : entryResults.gloss,
			    	soundfile:entryResults.soundfile === undefined ? '' : entryResults.soundfile,
			    	semantic_domain:entryResults.semantic_domain === undefined ? [] : entryResults.semantic_domain,
			    	reversal:entryResults.reversal === undefined ? [] : entryResults.reversal,
			    	notes2:entryResults.notes2 === undefined ? [] : entryResults.notes2,
			    	examples:entryResults.examples === undefined ? [] : entryResults.examples,
			    	Possessed:entryResults.Possessed === undefined ? '' : entryResults.Possessed,
			    	PossTlingit:entryResults.PossTlingit === undefined ? '' : entryResults.PossTlingit,
			    	examples_parse:entryResults.examples_parse === undefined ? {} : entryResults.examples_parse,

			    	Verb_Root:entryResults.Verb_Root === undefined ? '' : entryResults.Verb_Root,
			    	LeerEdwards_Theme:entryResults.LeerEdwards_Theme === undefined ? [] : entryResults.LeerEdwards_Theme,
			    	NaishStory_Theme:entryResults.NaishStory_Theme === undefined ? '' : entryResults.NaishStory_Theme,
			    	reversal:entryResults.reversal === undefined ? [] : entryResults.reversal,
			    	// Conjugation_Prefix:entryResults.Conjugation_Prefix === undefined ? '' : entryResults.Conjugation_Prefix,
			    	// Motion_Verbtype:entryResults.Motion_Verbtype === undefined ? '' : entryResults.Motion_Verbtype,
			    	// Valence:entryResults.Valence === undefined ? '' : entryResults.Valence,
			    	// Pronoun:entryResults.Pronoun === undefined ? '' : entryResults.Pronoun,
			    	semantic_domain:entryResults.semantic_domain === undefined ? [] : entryResults.semantic_domain,
			    	notes1:entryResults.notes1 === undefined ? [] : entryResults.notes1,
			    	notes2:entryResults.notes2 === undefined ? [] : entryResults.notes2,
			    	verb_paradigms:entryResults.verb_paradigms === undefined ? [] : entryResults.verb_paradigms,
			    	verb_paradigms_processed:entryResults.verb_paradigms_processed === undefined ? {} : entryResults.verb_paradigms_processed,
			    	verb_paradigms_roots:entryResults.verb_paradigms_roots === undefined ? [] : entryResults.verb_paradigms_roots,
			    	noun_paradigms:entryResults.noun_paradigms === undefined ? [] : entryResults.noun_paradigms,
			    	adverb_paradigms:entryResults.adverb_paradigms === undefined ? [] : entryResults.adverb_paradigms,
			    	siblings:entryResults.siblings === undefined ? [] : entryResults.siblings,
			    	homonyms:entryResults.homonyms === undefined ? [] : entryResults.homonyms,
			    	properties:entryResults.properties === undefined ? [] : entryResults.properties,
			    	moodPOS:moodPOS,
			    	POSCandidateList:POSCandidateList,
			    	SONP:entryResults.SONP === undefined ? [] : entryResults.SONP,
			    	loaded:true,

					})


        }


        // dictionary_prepared = fuzzysort.prepare(dictionary)

        // this.setState({ audiolibrary: audiolibrary });
      });
	}

  // getWord(word) {
  // 	scroll.scrollTo(0);
  // 	if (word in this.props.urlDictionary) {
  // 		console.log(this.props.urlDictionary[word])
	 //    this.setState({
	 //    	lexicon:this.props.urlDictionary[word].lexicon === undefined ? '' : this.props.urlDictionary[word].lexicon,
	 //    	pos:this.props.urlDictionary[word].pos === undefined ? '' : this.props.urlDictionary[word].pos,
	 //    	varsp:this.props.urlDictionary[word].varsp === undefined ? [] : this.props.urlDictionary[word].varsp,
	 //    	children:this.props.urlDictionary[word].children === undefined ? [] : this.props.urlDictionary[word].children,
	 //    	dialect:this.props.urlDictionary[word].dialect === undefined ? [] : this.props.urlDictionary[word].dialect,
	 //    	gloss:this.props.urlDictionary[word].gloss === undefined ? [] : this.props.urlDictionary[word].gloss,
	 //    	soundfile:this.props.urlDictionary[word].soundfile === undefined ? '' : this.props.urlDictionary[word].soundfile,
	 //    	semantic_domain:this.props.urlDictionary[word].semantic_domain === undefined ? [] : this.props.urlDictionary[word].semantic_domain,
	 //    	reversal:this.props.urlDictionary[word].reversal === undefined ? [] : this.props.urlDictionary[word].reversal,
	 //    	notes2:this.props.urlDictionary[word].notes2 === undefined ? [] : this.props.urlDictionary[word].notes2,
	 //    	examples:this.props.urlDictionary[word].examples === undefined ? [] : this.props.urlDictionary[word].examples,
	 //    	Possessed:this.props.urlDictionary[word].Possessed === undefined ? '' : this.props.urlDictionary[word].Possessed,

	 //    	Verb_Root:this.props.urlDictionary[word].Verb_Root === undefined ? '' : this.props.urlDictionary[word].Verb_Root,
	 //    	LeerEdwards_Theme:this.props.urlDictionary[word].LeerEdwards_Theme === undefined ? [] : this.props.urlDictionary[word].LeerEdwards_Theme,
	 //    	NaishStory_Theme:this.props.urlDictionary[word].NaishStory_Theme === undefined ? '' : this.props.urlDictionary[word].NaishStory_Theme,
	 //    	reversal:this.props.urlDictionary[word].reversal === undefined ? [] : this.props.urlDictionary[word].reversal,
	 //    	Conjugation_Prefix:this.props.urlDictionary[word].Conjugation_Prefix === undefined ? '' : this.props.urlDictionary[word].Conjugation_Prefix,
	 //    	Motion_Verbtype:this.props.urlDictionary[word].Motion_Verbtype === undefined ? '' : this.props.urlDictionary[word].Motion_Verbtype,
	 //    	Valence:this.props.urlDictionary[word].Valence === undefined ? '' : this.props.urlDictionary[word].Valence,
	 //    	Pronoun:this.props.urlDictionary[word].Pronoun === undefined ? '' : this.props.urlDictionary[word].Pronoun,
	 //    	semantic_domain:this.props.urlDictionary[word].semantic_domain === undefined ? [] : this.props.urlDictionary[word].semantic_domain,
	 //    	notes1:this.props.urlDictionary[word].notes1 === undefined ? [] : this.props.urlDictionary[word].notes1,
	 //    	notes2:this.props.urlDictionary[word].notes2 === undefined ? [] : this.props.urlDictionary[word].notes2,
	 //    	verb_paradigms:this.props.urlDictionary[word].verb_paradigms === undefined ? [] : this.props.urlDictionary[word].verb_paradigms,
	 //    	verb_paradigms_roots:this.props.urlDictionary[word].verb_paradigms_roots === undefined ? [] : this.props.urlDictionary[word].verb_paradigms_roots,

		// 	})
  // 	} else {
		// 	this.props.history.push('/')
		// }

  // }

  returnPOSCandidateList = (sonpList, properties) => {
  	let sonp = sonpList[0]
  	let Sonp = sonpList[1]
  	let sOnp = sonpList[2]
  	let soNp = sonpList[3]
  	let sonP = sonpList[4]
  	let Subj = ['']
  	let Obj = ['']
  	let Noun = ['']
  	let Preverb = ['']
  	if (sonp.includes('S')) {
  		if (Sonp == '3') {
  			Subj = ['3']
  		} else if (properties.includes('S_s_only')) {
  			Subj = ['1Sg','2Sg','3Sg','4H']
  		} else if (properties.includes('S_p_only')) {
  			Subj = ['1Pl','2Pl','3Pl','4H']
  		} else if (Sonp == '3Sg' || Sonp == '3Pl') {
  			Subj = ['1Sg','2Sg','3Sg','1Pl','2Pl','3Pl','4H']
  		} 
  	}
  	// console.log(sonpList, properties)
  	if (sonp.includes('O')) {
  		if (sOnp == '3') {
        Obj = ['3']
  		} else if (properties.includes('O_s_only')) {
        Obj = ['1Sg','2Sg','3Sg','4H','4N']
  		} else if (properties.includes('O_p_only')) {
        Obj = ['1Pl','2Pl','3Pl','4H','4N']
  		} else if (sOnp == '3Sg' || sOnp == '3Pl') {
        Obj = ['1Sg','2Sg','3Sg','1Pl','2Pl','3Pl','4H','4N']
  		} 
  	}  
  	if (sonp.includes('N')) {
  		if (soNp == 'a') {
        Noun = ['3']
  		} else if (soNp == 'du') {
        Noun = ['1Sg','2Sg','3Sg','1Pl','2Pl','3Pl','4H','4N']
  		}  
  	}  
  	if (sonp.includes('P')) {
  		Preverb = ['3']
  	}
  	let sonpKeyList = []
  	// if (['OP','SO','S','ON','SN','SOP','N','SP','SON','P','O'].includes(sonp)) { // SONP

  	// }
  	if (['NO','NS','OS'].includes(sonp)) { // PNOS NS NO
  		Preverb.map((p)=>{
  			Noun.map((n)=>{
  				Obj.map((o)=>{
  					Subj.map((s)=>{
  						if (s == 1 && o == 1) {
  						} else if (s == 2 && o == 2) {
  						} else {
  							let pernums = [s,o,n,p]
  							sonpKeyList.push(pernums.join('_'))
  						}
  					})
  				})
  			})
  		})  		
  	} else if (['SNO'].includes(sonp)) {
  		Subj.map((s)=>{
  			Noun.map((n)=>{
  				Obj.map((o)=>{
  					Preverb.map((p)=>{
  						if (s == 1 && o == 1) {
  						} else if (s == 2 && o == 2) {
  						} else {
  							let pernums = [s,o,n,p]
  							sonpKeyList.push(pernums.join('_'))
  						}
  					})
  				})
  			})
  		})
  	} else {
  		Subj.map((s)=>{
  			Obj.map((o)=>{
  				Noun.map((n)=>{
  					Preverb.map((p)=>{
  						if (s == 1 && o == 1) {
  						} else if (s == 2 && o == 2) {
  						} else {
  							let pernums = [s,o,n,p]
  							sonpKeyList.push(pernums.join('_'))
  						}
  					})
  				})
  			})
  		})
  	}
  	return sonpKeyList
  	// console.log(sonpKeyList)
  }

  retrieveMoodKey = (mood) => {
  	let returnKey = ''
  	this.state.moodPOS.map((m)=>{
  		if (m['name'] == mood) {
  			returnKey = m['key']
  		}
  	})
  	return returnKey
  }

  retrieveText = (dkeylist,newkey) => {
  	let returnText = ''
  	dkeylist.map((m)=>{
  		if (m['value'] == newkey) {
  			returnText = m['text']
  		}
  	})
  	return returnText
  }

  newMoodKey = (mood, e, data) => {
  	let copiedmoodPOS = [...this.state.moodPOS]
  	copiedmoodPOS.map((m)=>{
  		if (m['name'] == mood) {
  			m['key'] = data.value
  		}
  	})
  	this.setState({moodPOS:copiedmoodPOS})
  }


	processStyledText = (sentence) => {
		if (sentence !== undefined) {
			sentence = sentence.replace("⟨","").replace("⟩","").replace("«","").replace("»","")
			let matches = sentence.match(/⎡.*?⎤/g)
			let matches1 = sentence.match(/{.*?}/g)
			let matches2 = sentence.match(/_.*?_/g)
			if (matches !== null || matches1 !== null || matches2 !== null) {
				if (matches !== null) {
					matches.map((m) => sentence = sentence.replace(m,'<i>'+m.slice(1,-1)+'</i>'))						
				}
				if (matches1 !== null) {
					matches1.map((m) => sentence = sentence.replace(m,m.slice(1,-1)))						
				}
				if (matches2 !== null) {
					matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))						
				}
				return <span dangerouslySetInnerHTML={{__html: sentence}} />		
			} else {
				return <span>{sentence}</span>
			}
		}
	}

    processStyledTextLink = (sentence) => {
      sentence = sentence.replaceAll(">","")


      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","")
      let matches = sentence.match(/⎡.*?⎤/g)
      let matches1 = sentence.match(/{.*?}/g)
      let matches2 = sentence.match(/_.*?_/g)
      // console.log(matches2)
      if (matches !== null || matches1 !== null || matches2 !== null) {
        if (matches !== null) {
          matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
        }
        if (matches1 !== null) {
          matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
        }
        if (matches2 !== null) {
          matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
        }
        return <span style={{whiteSpace:'nowrap'}} dangerouslySetInnerHTML={{__html: sentence}} />    
      } else {
        return <span style={{whiteSpace:'nowrap'}}>{sentence}</span>
      }


      // let matches = sentence.match(/\⎡.*?\⎤/g)
      // if (matches !== null) {
      //   matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))   
      //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
      // } else {
      //   return <span>{sentence}</span>
      // }
    }


	processUnderlyingStyledText = (sentence) => {			
		sentence = sentence.replace("⟨","").replace("⟩","")
		let matches = sentence.match(/⎡.*?⎤/g)
		let matches1 = sentence.match(/\^.*?\^/g)
		let matches2 = sentence.match(/_.*?_/g)
		if (matches !== null || matches1 !== null || matches2 !== null) {
			if (matches !== null) {
				matches.map((m) => sentence = sentence.replace(m,'<i>['+m.slice(1,-1)+']</i>'))						
			}
			if (matches1 !== null) {
				matches1.map((m) => sentence = sentence.replace(m,'<sup>'+m.slice(1,-1)+'</sup>'))						
			}
			if (matches2 !== null) {
				matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))						
			}
			return <span dangerouslySetInnerHTML={{__html: sentence}} />		
		} else {
			return <span>{sentence}</span>
		}
	}

	processPostbaseExampleRow = (sentence) => {     
    let matches = sentence.match(/\`.*?(\`|\')/g)
    let matches2 = sentence.match(/\(.*?\)/g)

    // console.log(matches2)
    if (matches !== null) {
      matches.map((m) => sentence = '<b>'+sentence.replace(m,'<span style="font-weight:normal">'+m.slice(1,-1)+'</span>')+'</b>')
    }      
    if (matches2 !== null) {
      matches2.map((m) => sentence = sentence.replace(m,'<span style="font-weight:normal"><i>'+m+'</i></span>'))      
    }
    if (matches !== null || matches2 !== null) {
      return <span dangerouslySetInnerHTML={{__html: sentence}} />          
    } else {
      return <span>{sentence}</span>
    }
  }

  processPostbaseTableRowHTML = (sentence) => {
		let matchesB = sentence.match(/\{.*?\}(?!\w)/g)
    let matchesI = sentence.match(/⎡.*?⎤/g)
		let matchesSup = sentence.match(/\^.*?\^/g)
		let matchesSub = sentence.match(/_.*?_/g)
		if (matchesB !== null || matchesI !== null || matchesSup !== null || matchesSub !== null) {
			if (matchesB !== null) {
				matchesB.map((m) => sentence = sentence.replaceAll(m,'<b>'+m.slice(1,-1)+'</b>'))								
			}
			if (matchesI !== null) {
				matchesI.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))						
			}
			if (matchesSub !== null) {
				matchesSub.map((m) => sentence = sentence.replaceAll(m,'<sub>'+m.slice(1,-1)+'</sub>'))						
			}
			if (matchesSup !== null) {
				matchesSup.map((m) => sentence = sentence.replaceAll(m,'<sup>'+m.slice(1,-1)+'</sup>'))						
			}
			return sentence
		} else {
			return sentence
		}
  }

  returnNonLinguisticTerm = (term, bottom) => {
  	// console.log(term)
  	// bottom = 'bottom'
  	if (term in nonLinguistic) {
  		return <div style={{fontSize:'16px',color:(window.innerWidth < innerWidthSetting ? '#808080' : '#777777'),fontStyle:'italic',paddingTop:(window.innerWidth < innerWidthSetting ? '7px' : '10px'),paddingRight:(window.innerWidth < innerWidthSetting ? '5px' : '15px')}}>
                <Popup hideOnScroll on='click' position={bottom == 'bottom' ? 'bottom':'bottom right'} content={
                  <div style={{fontFamily:customFontFam,}}>
                    {term.replaceAll('_',' ')}
                  </div>
                } trigger={
                  <span style={{cursor:'pointer',paddingBottom:'3px', borderBottom:'2px dotted #d5d5d5'}}>
                  	{nonLinguistic[term]}
                  </span>
                } />
						</div>  		
  	} else {
  	return 	<div style={{fontSize:'16px',color:(window.innerWidth < innerWidthSetting ? '#808080' : '#777777'),fontStyle:'italic',paddingTop:(window.innerWidth < innerWidthSetting ? '8px' : '10px'),paddingRight:(window.innerWidth < innerWidthSetting ? '5px' : '15px')}}>
							{this.processStyledText(term.replaceAll('_',' '))}
						</div>  		
					}
  }

  getPOSunderlying = (e) => {
  	let esplit = e.split('_')
  	let elist = []
  	if (this.state.SONP[0].length == 1) {
  		elist = [e.replaceAll('_','')]
  	} else if (this.state.SONP[0] == 'SP') {
  		elist = [esplit[0]]
  	} else if (this.state.SONP[0] == 'SO') {
  		elist = [esplit[0],esplit[1]]
  	} else if (this.state.SONP[0] == 'ON') {
  		elist = [esplit[1],esplit[2]]
  	} else if (this.state.SONP[0] == 'SN') {
  		elist = [esplit[0],esplit[2]]
  	} else if (this.state.SONP[0] == 'NO') {
  		elist = [esplit[2],esplit[1]]
  	} else if (this.state.SONP[0] == 'NS') {
  		elist = [esplit[2],esplit[0]]
  	} else if (this.state.SONP[0] == 'OS') {
  		elist = [esplit[1],esplit[0]]
  	}
  	let dictPOSunderlying = {
  		'1Sg':'1st Person Singular',
  		'1Pl':'1st Person Plural',
  		'2Sg':'2nd Person Singular',
  		'2Pl':'2nd Person Plural',
  		'3':'3rd Person',
  		'3Sg':'3rd Person Singular',
  		'3Pl':'3rd Person Plural',
  		'4H':'4th Person Human',
  		'4N':'4th Person Non-Human',
  	}

	  return elist.map((j,jindex)=>{
			 			return <span>
		  				{jindex != 0 ?
		  					<span style={{color:'#a1a1a1'}}>{'-'}</span>
		  					:
		  					null
		  				}
		  				{j in dictPOSunderlying ?
				 				<Popup hideOnScroll on='click' position='bottom center' content={
	                <span style={{fontFamily:customFontFam,}}>
	                  {dictPOSunderlying[j]}
	                </span>
	              } trigger={
	                <span style={{cursor:'pointer',fontStyle:'italic',color:'#979797'}}>
	                	{j}
	                </span>
	              } />
	              :
                <span style={{marginRight:'8px',fontStyle:'italic',color:'#979797'}}>
									{j}
								</span>  	
	            }
		  				{jindex == elist.length-1 ? 
		  					<span style={{marginRight:'8px',color:'#979797'}}>{': '}</span> 
		  					:
		  					null
		  				}
              </span>
	  })

  }

  reOrderPOS = (listtoreorder) => {
  	if (listtoreorder.length == 7) {
  		let newlistreturn = [listtoreorder[1],listtoreorder[0],listtoreorder[3],listtoreorder[2],listtoreorder[5],listtoreorder[4],listtoreorder[6]]
  		return newlistreturn
  	} else if (listtoreorder.length == 2) {
  		let newlistreturn = [listtoreorder[1],listtoreorder[0]]
  		return newlistreturn
  	} else if (listtoreorder.length == 3) {
  		let newlistreturn = [listtoreorder[1],listtoreorder[0],listtoreorder[2]]
  		return newlistreturn
  	}
  	return listtoreorder
  }

  boldSubjects = (sentence) => {
  	let boldtheseones = ['You all ',' you all ',' me ',' us ',' him/her ',' him/her/it ',]
  	let matched = false
  	return <span>
  	{boldtheseones.map((b,bindex)=>{
  		if (sentence.includes(b)) {
	  			let splitted = sentence.split(b)
	  			if (splitted.length>2) {
	  				sentence = splitted[1]+b+splitted[2]
	  			} else {
	  				sentence = splitted[1]	  				
	  			}
	  			matched = true
	  			return <span>
	  							<span>{splitted[0]}</span>
	  							<span style={{fontWeight:500}}>{b}</span>
	  						</span>
  		}
  		if (!matched && bindex == boldtheseones.length-1) {
  			return sentence
  		}
  	})}
  		{matched ?  <span>{sentence}</span> : null}  		
  	</span>
  }

  // processPostbaseTableRow = (sentence) => {     
		// let matchesBnL = sentence.match(/\{(.*?)\}⟨(.*?)⟩/g)
		// let splitSentence = []
		// let sentenceBank = []
		// let restOfSentence = sentence
		// if (matchesBnL !== null) {
		// 		let before = ''
		// 		let after = ''
		// 		matchesBnL.map((m) => {
		// 			before = restOfSentence.slice(0, restOfSentence.indexOf(m));
		// 			after = restOfSentence.slice(restOfSentence.indexOf(m)+m.length + 1);
		// 			sentenceBank.push(before)
		// 			restOfSentence = after
		// 		})
		// 		sentenceBank.push(after)
		// 		splitSentence = sentence.split(matchesBnL[0])
		// 		return <span>
		//  		<span dangerouslySetInnerHTML={{__html: this.processPostbaseTableRowHTML(sentenceBank[0])}} />

		// 	 		{matchesBnL.map((k,index)=><span>			 			
		// 			<Link style={{color:'#306190'}} to={{pathname: k.match(/⟨.*?⟩/g)[0].slice(1,-1)}} onClick={()=>{this.setState({key:k.match(/⟨.*?⟩/g)[0].slice(1,-1), from:this.props.location.pathname})}}><b>{k.match(/\{.*?\}/g)[0].slice(1,-1)}</b></Link>
		// 			{' '}
		// 	 		<span dangerouslySetInnerHTML={{__html: this.processPostbaseTableRowHTML(sentenceBank[index+1])}} />			
		// 	 		</span>	 			
		//  		)}
		// 		</span>
		// } else {
		//  	return <span dangerouslySetInnerHTML={{__html: this.processPostbaseTableRowHTML(this.processPostbaseTableRowHTML(sentence))}} />		
		// }
  // }

  // repeatAudio(audio, event, data) {
  // 	console.log(audio)
  //   if (!this.state.playingAudio) {

  //     let sound = new Audio(API_URL +  "/tlingitaudiolibrary/" +  audio);
  //     // let sound = new Audio("https://www.inupiaqonline.com/fastapi" + "/tlingitaudiolibrary/" +  audio);
  //     this.setState({playingAudio: true});

  //     sound.play()

  //     sound.onended=()=>{
  //       this.setState({playingAudio: false});
  //     }
  //   }
  // }

  repeatAudio(audio, index, event, data) {
  	console.log(audio)
    let audioURL = API_URL + "/tlingitaudiolibrary/" +  audio;

    // stop audio on double click
    if (this.state.playingAudio === true && this.state.clickedAudioUrl === audioURL) {
      let audio = this.state.clickedAudio;
      audio.pause();
      audio.currentTime = 0;
      this.setState({clickedAudio:audio, clickedAudioIndex:-1, playingAudio: false})
    }

    // stop first audio then play new one
    if (this.state.playingAudio === true && this.state.clickedAudioUrl !== audioURL) {
      let firstAudio = this.state.clickedAudio;
      firstAudio.pause();
      firstAudio.currentTime = 0;

      this.setState({playingAudio: true});
      let secondAudio = new Audio(audioURL);
      secondAudio.play();
      this.setState({clickedAudioUrl:audioURL,  clickedAudioIndex:index, clickedAudio:secondAudio})
      secondAudio.onended=()=>{this.setState({playingAudio: false,clickedAudioIndex:-1,})};
    }

    // play audio again
    if (this.state.playingAudio === false && this.state.clickedAudioUrl === audioURL) {
      let audio = this.state.clickedAudio;
      this.setState({playingAudio: true,  clickedAudioIndex:index, });
      audio.play();
      audio.onended=()=>{this.setState({playingAudio: false,clickedAudioIndex:-1,})};
    }

    // play new audio
    if (this.state.playingAudio === false && this.state.clickedAudioUrl !== audioURL) {
      this.setState({playingAudio: true});
      let audio = new Audio(audioURL);
      audio.play();
      this.setState({clickedAudioUrl:audioURL, clickedAudioIndex:index, clickedAudio:audio})
      audio.onended=()=>{this.setState({playingAudio: false,clickedAudioIndex:-1,})};
    }

  }



  handleSortChange = (e, {value}) => {
    if (value === 0 && this.state.sortValue !== 0) {
      this.setState({sortValue: 0})
    } else if (value === 1 && this.state.sortValue !== 1) {
      this.setState({sortValue: 1})
    }
	}


  displayAudioMic = (audioRetrieved,sentenceid) => {
  	// console.log(audioRetrieved)
  	// console.log(sentenceid)
    return <Popup
            content={
              <List style={{fontFamily:customFontFam}} divided verticalAlign='middle'>
                {audioRetrieved.map((k,kindex)=>{
                  return <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Button style={{float:'left', border:(this.state.playingAudio && this.state.clickedAudioIndex === sentenceid+kindex ? 'solid 1px #4a80b5' : 'solid 1px #dededf'),marginLeft:5,backgroundColor:'white', color:'#106181',cursor:'pointer'}} circular icon='volume up' onClick={()=>this.repeatAudio(k['filename'], sentenceid+kindex)} />
                          <div style={{display:'flex',flexDirection:'column',marginLeft:10,padding:'5px 0px'}}>
                            {k['gender'] != 'do_not_wish_to_say' ?
                              <div>{k['gender'].replaceAll('_',' / ')}</div>
                              :
                              null
                            }
                            {k['age'] != 'do_not_wish_to_say' ?
                              <div>{k['age']}</div>
                              :
                              null
                            }
                            {k['village'] != 'do_not_wish_to_say' ?
                              <div>{k['village']}</div>
                              :
                              null
                            }
                            {k['gender'] == 'do_not_wish_to_say' && k['age'] == 'do_not_wish_to_say' && k['village'] == 'do_not_wish_to_say' ?
                              <div>{'Anonymous Clip'}</div>
                              :
                              null
                            }                            
                          </div>
                        </ListItem>
                })}
                <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                  <Button circular basic style={{opacity:0.9,marginLeft:5,fontSize:'14px'}} onClick={()=>{this.setState({openPopup:-1},()=>{this.setState({showModal:sentenceid})})}} icon='microphone' />
                  <div style={{marginLeft:10,padding:'5px 0px'}}>Submit a Recording for haashuka.com</div>
                </ListItem>
              </List>
              }
            on='click'
            open={this.state.openPopup==sentenceid}
            onClose={()=>this.setState({openPopup:-1})}
            style={{padding:8}}
            position='bottom center'
            trigger={<Button size='tiny' onClick={()=>{this.setState({openPopup:sentenceid})}} style={{paddingRight:15, marginLeft:10}} circular basic icon>{audioRetrieved.length == 0 ? <Icon style={{color:'#b7b7b7'}} name='microphone' />:<Icon style={{color:'#306190'}} name='volume up' />}<Icon style={{color:'#d2d2d2',paddingLeft:'6px',fontSize:'9px'}} name='chevron down' /> </Button>}
          />
  }

  recordClip = (sentenceid, sentence, siteLocation, english) => {
   			if (english == undefined) {
  				english = ''
  			}
  			// console.log(english, siteLocation)
        return <Modal
            on='click'
            open={this.state.showModal==sentenceid}
            style={{
              maxWidth:500,
              marginTop:(window.innerWidth < 480 ? 10 : 10),
            }}
            closeOnDimmerClick={false}
            onOpen={()=>{
            }}
            onClose={()=>{
              this.setState({showModal:-1})
            }}
          >
          <ModalContent>
            <Icon circular style={{margin:0,color:'#929292',cursor:'pointer',position:'relative',float:'right'}} size='large' onClick={()=>{this.setState({showModal:-1});}} name='x' />
            <Recorder english={english} sentence={sentence} siteLocation={siteLocation} />          
          </ModalContent>
          </Modal>
  }

  returnExampleList = (tlingitList) => {
  	let tlingitString = ''
  	tlingitList.map((k)=>{tlingitString += k[0]+' '})
  	return tlingitString.trim()
  }

	render() {
		console.log(this.state)
		let postbaseTableOn = false
    let postbaseExampleOn = false
    let greyed = true
    let display1 = true
    // let display1 = false
    let display2 = true
    // let display2 = false
    let display3 = true
    // let display3 = false
    let testList = [[
	"Ax̲", [
		{"word": "ax̲", "span": [0, 3], "links": 19}]],[
	"atx'aan hídi", [
		{"word": "atx'aan hídi", "span": [4, 16], "links": 1}, 
		{"word": "atx'aan", "span": [4, 11], "links": 1}, 
		{"word": "hídi", "span": [12, 16], "links": 3}]],[
	"tleidooshú", [
		{"word": "tleidooshú", "span": [17, 27], "links": 1}]],[
	"k̲aa x̲'oos", [
		{"word": "k̲aa x̲'oos", "span": [28, 39], "links": 2}, 
		{"word": "k̲aa", "span": [28, 32], "links": 37}, 
		{"word": "x̲'oos", "span": [33, 39], "links": 5}]],[
	"k̲a", [
		{"word": "k̲a", "span": [40, 43], "links": 6}]],[
	"daax'oonx̲", []],[
	"sitee.", [
		{"word": "sitee", "span": [55, 61], "links": 1}]]]
		// console.log(this.props.location)
		// console.log(this.props)
		return (
			<div className="app" style={{fontFamily:customFontFam}}>
			<Transition visible={this.state.loaded} animation='fade' duration={300}>
      <Grid textAlign='center'>
      <Grid.Row  style={{height:40,paddingBottom:0}}>
      <Grid.Column style={{ maxWidth: 800, padding: 10 }} textAlign='left'>
					{this.state.from === '/' ?
						<Link to={{pathname: "/", state: { currentCategory:this.state.prevCategory, history:this.state.history }}} >
	          	<Icon circular style={{margin:0,color:'#B1B1B1',cursor:'pointer'}} size='large' name='chevron left' />
	          </Link>
						:
          	<Icon onClick={()=>{this.props.history.goBack()}} circular style={{margin:0,color:'#B1B1B1',cursor:'pointer'}} size='large' name='chevron left' />
					}
					<Link to={{pathname: "/"}}>
          <Icon circular style={{margin:0,marginLeft:5,color:'#B1B1B1',cursor:'pointer'}} size='large' name='search' />
					</Link>					

					<div style={{fontSize:'23px',marginTop:'20px',fontFamily:customFontFam}}>
						<div>
          		<div style={{display:'flex',paddingBottom:'7px'}}> 
              <span style={{fontWeight:'500',lineHeight:'30px'}}>
              {this.processStyledTextLink(this.state.lexicon)}

								{this.state.disableRecord ?
	              	(typeof this.state.soundfile !== "undefined" && this.state.soundfile.length !== 0 ?
										<Icon circular onClick={()=>this.repeatAudio(this.state.soundfile[0]['filename'])} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
										:
										null
	              	)
									:
									<span>
			            {this.state.soundfile.length != 0 && !this.state.disableRecord ?
			              this.displayAudioMic(this.state.soundfile,'b')
			              :
			              null
			            }

			            {this.state.showModal != -1 ?
			              this.recordClip('b',this.state.lexicon,'entryUsage1',this.state.gloss.join('; '))
			              :
			              null
			            }
			          	</span>
								}

              </span>


                <span style={{'marginLeft':'12px',marginTop:'3px'}}>
	              {this.state.dialect.length !== 0 ?
	              	(this.state.dialect.map((d)=>
		                <span style={{marginRight:'5px'}}>
		                  <TagColors tags={d} width={-1} />
		                </span>
		                )
	              	)
	                :
	                ''
	              }   
	              {this.state.pos !== '' ?
	                <span style={{marginRight:'5px'}}>
	                  <TagColors tags={this.state.pos} width={-1} />
	                </span>
	                :
	                ''
	              }       
	              </span>      
              </div>
            </div>
					</div>

					{typeof this.state.varsp !== undefined && this.state.varsp.length !== 0 ?
						<div style={{fontStyle:'italic',fontSize:'18px',marginTop:'5px',color:'#000000cc'}}>
							{this.state.varsp.map((v,vind)=>
								<div style={{marginBottom:'8px',lineHeight:'22px'}}>
									{v[0].replace("⎡","[").replace("⎤","]").replace('pl.','plural').replace("⎡or⎤","or")+'\n\n'}

									{this.state.disableRecord ?
		              	(typeof v[2] !== "undefined" && v[2] !== 0 ?
											<Icon circular onClick={()=>this.repeatAudio(v[2][0]['filename'])} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
											:
											null
		              	)
										:
										<span>
				            {v[2] != null && !this.state.disableRecord ?
				              this.displayAudioMic(v[2],'h'+vind.toString())
				              :
				              null
				            }

				            {this.state.showModal != -1 ?
				              this.recordClip('h'+vind.toString(),v[0],'entryUsage2',this.state.gloss.join('; '))
				              :
				              null
				            }
				          	</span>
									}
								
	                <span style={{'marginLeft':'12px',marginTop:'3px'}}>
		              {v[1].length !== 0 ?
		              	(v[1].map((d)=>
			                <span style={{marginRight:'5px'}}>
			                  <TagColors tags={d} width={-1} />
			                </span>
			                )
		              	)
		                :
		                ''
		              }      
		              </span>

								</div>
							)}
						</div>
						:
						null
					}



					<div style={{border:'1px solid #E3E3E3',marginTop:'14px'}}>


					{this.state.gloss.length != 0 ?
					<div>
						<div className='hierarchymain'>
						<span className='span1'></span>
						<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Definition</span>
						</div>

						<div style={{marginTop:'17px',marginBottom:'18px'}}>
						{this.state.gloss.map((d,ind) => 
							<div>
							<div style={{display:'flex',alignItems:'center',margin:'13px 0px',marginBottom:'10px'}}>
							<span style={{marginLeft:'10px',color:'#777777',fontSize:'20px','fontWeight':'300'}}>{'○'}</span>
							<span style={{marginLeft:'20px',color:'#000000',fontSize:'20px',lineHeight:'24px'}}>
							{this.processStyledText(d)}
							</span>
							</div>

							{this.state.PossTlingit.length > 0 && ind == 0 ?
				        <div style={{marginLeft:'45px',color:'#5c5c5c',marginTop:'10px', marginBottom:'20px'}}>
				          <div style={{marginBottom:5,fontSize:'18px',fontWeight:'400'}}>
				            <div style={{lineHeight:'35px',marginLeft:'2px'}}>
				              {possessorEnglish[this.state.possValue]+' '+this.state.PossTlingit}
				            </div>
				          </div>
				          <span>
				            <div style={{fontSize:'16px',marginBottom:'20px',color:'#5c5c5c',fontWeight:'300'}}>          
				            <Dropdown inline scrolling style={{border:'solid 1px #22242626',color:'#5c5c5c',padding:'5px',borderRadius:'5px',marginRight:'4px'}} defaultValue='311' onChange={(e,data)=>{this.setState({possValue:data.value})}} options={nounOptionsMVPossessorsThe} />
				            	<span>{d.replaceAll('his/her ','').replaceAll('his/her/its ','')}</span>
				            </div>
				          </span>
				        </div>
				        :
				        (this.state.Possessed.length > 0 ?
					        <div style={{marginLeft:'43px',color:'#5c5c5c',marginTop:'10px', marginBottom:'20px'}}>
					          <span>
					            <div style={{fontSize:'16px',margin:'15px 0px',color:'#5c5c5c',fontWeight:'300'}}>          
					            	<span>{this.state.Possessed+": "+'his/her '+d.replaceAll('his/her ','').replaceAll('his/her/its ','')}</span>
					            </div>
					          </span>
					        </div>        	
				        	:
				        	null
				        )
				      }

							</div>

							)}
						</div>
						</div>
						:
						null
					}


					{this.state.examples.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Example Sentences</span>
							</div>

							{this.state.examples.map((d,ind) => 
								<div style={{marginTop:'18px'}}>



									<div style={{marginTop:'15px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'8px',fontSize:'20px',lineHeight:'34px'}}>

	                {d[1].map((t,tindex)=>{
	                	let entries = [...t[1],...t[2]]
	                	let maxLength = (entries.length % 2 == 0 ? entries.length/2 : (entries.length+1)/2)
	                	if (entries.length === 0) {

	                  	return <span style={{ marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'1px',fontSize:'20px', borderBottom:'2px dotted white'}}>
	                      {this.processStyledText(t[0]+' ')}
	                    </span>

	                	} else {

		                  return <span><Popup hideOnScroll on='click' position='bottom left' onClose={()=>{this.setState({parseIndex:0})}} content={
		                    <div style={{fontFamily:customFontFam, fontSize:'16px'}}>
		                    	<div style={{textAlign:'center',fontStyle:'italic',color:'#aeaeae',margin:3}}>Possible Entries</div>
		                      {entries.map((k,kindex)=>{
		                      	if (kindex == this.state.parseIndex*2 || kindex == this.state.parseIndex*2+1) {
		                      	return <div style={{marginTop:15,marginBottom:10}}>
		                      			<div style={{display:'flex',alignItems:'center',flexDirection:'row',fontWeight:'500'}}>
		                      				<a style={{whiteSpace:'nowrap'}} href={"https://www.haashuka.com/"+k['url']}>{k['tlingit']}</a>
				                        	{k['tags'].map((t,tindex)=>
					                        		(tindex == 0 ?
						                          <span style={{display:'flex',marginLeft:'12px'}}>
						                            <TagColors homeMode={0} tags={t} width={window.innerWidth} />
						                          </span>
						                          :
						                          null
				                        			)
					                        	)}
		                      			</div>
		                      			<div style={{fontStyle:'italic',marginTop:'5px'}}>{k['english']}</div>
		                      	</div>
		                      	}})}

		                      {this.state.parseIndex+1 < maxLength+1 && maxLength > 1 ?
			                      <div style={{display:'flex',justifyContent:'center',marginTop:'12px'}}>
										        <Icon disabled={this.state.parseIndex === 0} circular onClick={() => this.setState({parseIndex: this.state.parseIndex-1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron left' />
										        <Label disabled active={false} basic circular style={{width:30,color:'#aeaeae',fontWeight:500,height:30,fontSize:14,}}>
										          {this.state.parseIndex + 1}
										        </Label>
										        <Icon disabled={this.state.parseIndex+1 == maxLength} circular onClick={() => this.setState({parseIndex: this.state.parseIndex+1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron right' />
										        </div>  
										        :
										        null
									        }      
	  
		                    </div>
		                  } trigger={
		                    <span style={{cursor:'pointer', marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'1px',fontSize:'20px', wordWrap:'break-word',borderBottom:'2px dotted #d5d5d5'}}>
		                      {this.processStyledText(t[0])}
		                    </span>
		                  } /><span>{' '}</span></span>

	                	}

	                })}


									{this.state.disableRecord ?
										(d[3] !== null && d[3].length > 0 ?
											<Icon circular onClick={()=>this.repeatAudio(d[3][0]['filename'])} style={{marginLeft:'5px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
											:
											null
										)
										:
										<span>
				            {this.state.examples[ind][3] != null && !this.state.disableRecord ?
				              this.displayAudioMic(this.state.examples[ind][3],'a'+ind.toString())
				              :
				              null
				            }

				            {this.state.showModal != -1 ?
				              this.recordClip('a'+ind.toString(),this.returnExampleList(this.state.examples[ind][1]),'entryUsage3',this.state.examples[ind][2])
				              :
				              null
				            }
				          	</span>
									}

									</div>


									<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>
									<span>
									{this.processStyledText(d[2])}
									</span>
									</div>



								</div>
								)}


								<div style={{margin:22,paddingTop:'10px',fontSize:'16px',fontStyle:'italic',color:'#777777'}}>Recordings are from the <a href="http://ankn.uaf.edu/~tlingitverbs/examples.html" target="_blank">Tlingit Example Sentences with Audio</a> website.</div>

                <span style={{display:'flex',flexDirection:'row',alignItems:'center',flexWrap:'wrap',fontSize:'20px',lineHeight:'30px'}}>
                

                </span>

						</div>
						:
						null
					}

					{this.state.LeerEdwards_Theme.length !== 0 || this.state.NaishStory_Theme.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Theme</span>
							</div>
							{this.state.LeerEdwards_Theme.length !== 0 ?
								<div style={{fontSize:'16px',margin:'20px 20px',marginRight:'0px'}}>
									<div style={{marginBottom:'15px',color:'#777777',fontStyle:'italic'}}><span>{'Leer-Edwards Theme'}</span></div>
									<div style={{marginBottom:'10px',fontSize:'20px'}}>
									{this.state.LeerEdwards_Theme[0].map((j)=>{return <span style={{lineHeight:'28px'}}>{this.processStyledText(j)}</span>})}
									</div>
									{this.state.LeerEdwards_Theme[1].map((j)=>{
										return 	<div style={{margin:'3px 0px'}}>
															<span style={{color:'#777777',fontSize:'20px','fontWeight':'300'}}>{'○'}</span>
															<span style={{marginLeft:'20px'}}>
																{this.processStyledText(j)}
															</span>
														</div>
									})}
								</div>
								:
								null
							}
							{this.state.NaishStory_Theme.length !== 0 ?
								<div style={{fontSize:'16px',margin:'20px 20px',marginRight:'0px'}}>
									<div style={{marginBottom:'15px',color:'#777777',fontStyle:'italic'}}><span style={{}}>{'Naish-Story Theme'}</span></div>
									<div style={{marginBottom:'10px',fontSize:'20px'}}>
										<span style={{lineHeight:'28px'}}>{this.processStyledText(this.state.NaishStory_Theme)}</span>
									</div>
								</div>
								:
								null
							}
						</div>
						:
						null
					}



					{this.state.notes1.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Notes 1</span>
							</div>
							{this.state.notes1.map((d) => 
								<div style={{marginTop:'18px',marginBottom:'18px'}} className='extrainformation'>{this.processStyledText(d)}</div>
							)}
						</div>
						:
						null
					}

					{this.state.notes2.length !== 0 && false ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Notes 2</span>
							</div>
							{this.state.notes2.map((d) => 
								<div style={{marginTop:'18px',marginBottom:'18px'}} className='extrainformation'>{this.processStyledText(d)}</div>
							)}
						</div>
						:
						null
					}



					{Object.keys(this.state.verb_paradigms_processed).length == 0 && Object.keys(this.state.verb_paradigms_roots).length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Verb Paradigms</span>
							</div>
							{moodList.map((d,ind) =>
								(d in this.state.verb_paradigms_roots ?
									(Object.keys(this.state.verb_paradigms_roots[d]).map((e,eindex)=>
										<div style={{marginTop:'18px'}}>
											<div style={{display:'flex',marginTop:'15px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'5px',justifyContent:'space-between'}}>
												<div style={{fontSize:'20px',lineHeight:'34px'}}>
													{this.state.verb_paradigms_roots[d][e][0].map((j,jindex)=>
														<span style={{color:(j.includes('does not occur') || j.includes("ee '") ? '#b4b4b4':null)}}>
															{this.processStyledText(j)}

															{this.state.disableRecord ?
																(this.state.verb_paradigms_roots[d][e][2][jindex] != null && this.state.verb_paradigms_roots[d][e][2][jindex].length > 0 ?
																	<Icon circular onClick={()=>this.repeatAudio(this.state.verb_paradigms_roots[d][e][2][jindex][0]['filename'])} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
																	:
																	null
																)
																:
																<span>
										            {this.state.verb_paradigms_roots[d][e][2][jindex] != null && !this.state.disableRecord ?
										              this.displayAudioMic(this.state.verb_paradigms_roots[d][e][2][jindex],'r'+ind.toString()+'-'+eindex.toString())
										              :
										              null
										            }

										            {this.state.showModal != -1 ?
										              this.recordClip('r'+ind.toString()+'-'+eindex.toString(),this.state.verb_paradigms_roots[d][e][0][jindex],'entryUsage4',this.state.verb_paradigms_roots[d][e][1][jindex])
										              :
										              null
										            }
										          	</span>
															}

															{jindex !== this.state.verb_paradigms_roots[d][e][0].length-1 ? ', ' : ''}
														</span>
													)}
												</div>
												{eindex == 0 ? <div style={{textAlign:'right',lineHeight:'27px'}}>{this.returnNonLinguisticTerm(d)}</div> : null}
											</div>
											<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>
												{this.state.verb_paradigms_roots[d][e][1].map((j,jindex)=><span>{this.processStyledText(j)}{jindex !== this.state.verb_paradigms_roots[d][e][1].length-1 ? ', ' : ''}</span>)}
											</div>
										</div>									
									))
									:
									null
								)
							)}
						</div>
						:
						null
					}


					{Object.keys(this.state.verb_paradigms_processed).length != 0 ?
						<div>
								{window.innerWidth < innerWidthSetting && false ?
                  <div style={{backgroundColor:'#F3F3F3'}}>
                    
                    <div className='hierarchymain' style={{flex:2,height:'100%',padding:'8px 0px',paddingTop:'12px',marginLeft:10}}>
                          <span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>{'Verb Paradigms'}</span>
                    </div>
                     

                    <div className='hierarchymain' style={{flex:2,justifyContent:'center',height:'100%',padding:'5px 0px',marginLeft:10}}>
                    <span className='span2' style={{fontSize:(window.innerWidth < innerWidthSetting ? '15px':'16px')}}>Format:</span>
                    <Dropdown options={options} value={this.state.sortValue} onChange={this.handleSortChange} pointing='top right' style={{backgroundColor:'white',border:'1px solid #e3e3e3',display:'flex',fontFamily:customFontFam,fontSize:(window.innerWidth < innerWidthSetting ? '15px':'16px'),fontWeight:400,color:'#777777',padding:7,borderRadius:5,marginLeft:5}} />
                    </div>

                  </div>
                  :
                  <div style={{display:'flex',backgroundColor:'#F3F3F3',flexDirection:'row',justifyContent:'space-between',alignItems:'center'}}>
                    
                    <div className='hierarchymain' style={{flex:2,height:'100%',padding:'12px 0px',marginLeft:10}}>
                          <span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>{'Verb Paradigms'}</span>
                    </div>
                     

                    <div className='hierarchymain' style={{flex:2,justifyContent:'flex-end',height:'100%',padding:'5px 0px',marginRight:15}}>
                    {window.innerWidth < innerWidthSetting ?
                    	null
                    	:
                    	<span className='span2' style={{marginLeft:25,fontSize:(window.innerWidth < innerWidthSetting ? '15px':'16px')}}>Format:</span>
                    }
                    <Dropdown options={options} value={this.state.sortValue} onChange={this.handleSortChange} pointing='top right' style={{backgroundColor:'white',border:'1px solid #e3e3e3',display:'flex',fontFamily:customFontFam,fontSize:(window.innerWidth < innerWidthSetting ? '15px':'16px'),fontWeight:400,color:'#777777',padding:7,borderRadius:5,marginLeft:5}} />
                    </div>

                  </div>
                }

              <div style={{fontStyle:'italic', color:'#a5a5a5', fontSize:'14px', margin:'20px 22px', textAlign:'center'}}> Words with <Image style={{margin:'0px 3px',cursor:'pointer',height:'14px',opacity:'0.4',display:'inline'}} src={'ai1.jpg'}/> are computer generated.  This word builder is still in development.  There may be mistakes with generated results and translations.</div>

							{this.state.sortValue == 1 ? // EXPANDED LIST
								(moodList.map((d,ind) =>
									{
										if (d in this.state.verb_paradigms_processed) {
										let ddict = this.state.verb_paradigms_processed[d][1]
										return (this.state.verb_paradigms_processed[d][0] != 'DNE' ?
											<div style={{marginTop:'10px',paddingBottom:'12px'}}>
												<div style={{textAlign:'center',marginBottom:'20px'}}>
													{this.returnNonLinguisticTerm(d,'bottom')}
												</div>
												{this.state.POSCandidateList.map((e,eindex)=>
													(e in ddict ?
													<div style={{display:'flex',flexDirection:'row',margin:(window.innerWidth < 480 ? '12px 14px':'12px 28px'),alignItems:'center'}}>
													{display1 ?
														<div style={{flex:5,display:'flex',flexDirection:'column',fontSize:(window.innerWidth < 480 ? '18px':'20px'),fontWeight:'400',lineHeight:'24px'}}>
														{ddict[e][0].map((tlingit,tindex)=>
															{ if (tindex == 0) {greyed = true}
																if (tlingit[1] == 'o') {greyed = false}
																return <span style={{display:'flex'}}>
															{tlingit[1] == 'g' ?
		                              <Popup hideOnScroll on='click' position='center' content={
		                                <span style={{fontFamily:customFontFam, fontSize:'14px'}}>
		                                  <span>{'computer generated'}</span>
		                                </span>
		                              } trigger={
		                              	<span style={{cursor:'pointer'}}>
		                              	<span style={{color:"#646464"}}>{tlingit[0]}</span>
		                              	<Image style={{marginLeft:'3px',marginBottom:'12px',height:'14px',opacity:'0.4', display:'inline'}} src={'ai1.jpg'}/>
		                              	</span>
		                              } />
	                              :
	                              (tlingit[1] == 'd' ?
																	<span style={{fontWeight:400,color:'#b4b4b4',fontSize:'18px'}}>{tlingit[0]}</span>
	                              	:
	                              	<span>{tlingit[0]}</span>
	                              	)
	                            }

															{this.state.disableRecord ?
																(tlingit[2] != null && tlingit[2].length > 0 ?
																	<div style={{height:'25px'}}><Icon circular onClick={()=>this.repeatAudio(tlingit[2][0]['filename'])} style={{marginLeft:'8px',fontSize:'14px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' /></div>
																	:
																	null
																)
																:
																<span>
										            {tlingit[2] != null && !this.state.disableRecord ?
										              this.displayAudioMic(tlingit[2],'p'+ind.toString()+'-'+eindex.toString())
										              :
										              null
										            }

										            {this.state.showModal != -1 ?
										              this.recordClip('p'+ind.toString()+'-'+eindex.toString(),tlingit[0],'entryUsage5',ddict[e][3])
										              :
										              null
										            }
										          	</span>
															}


															{ddict[e][0].length > tindex+1 ?
																<span style={{marginRight:'6px',marginLeft:'1px',color:(greyed ? "#646464":'#3a3a3a')}}>{', '}</span>
																:
																null
															}															
															</span>}
														)}
														</div>
														:
														null
													}
														{display2 && this.state.displaypos && window.innerWidth >= innerWidthSetting ?
															<div style={{flex:1,textAlign:(this.state.SONP[0].length == 1 ? 'right':'left')}}>{this.getPOSunderlying(e)}</div>
															:
															null
														}

														{display3 ?
														 <div style={{flex:4,color:(greyed ? "#646464":'#000000DE'),marginLeft:'5px',fontSize:'16px'}}>
															{window.innerWidth < innerWidthSetting && ddict[e][2].length > 0 && ddict[e][1].length != 0 ?
								                <Popup hideOnScroll on='click' position='bottom right' content={
																	<div style={{fontSize:'16px'}}>
																		<div>
																		<div style={{textAlign:'center',fontStyle:'italic',color:'#aeaeae'}}>Also:</div>
																		<div style={{color:'#000000DE',margin:3}}>{ddict[e][2].join(', ')}</div>
																		</div>
																	</div>
								                } trigger={
								                	ddict[e][1].length > 0 ?
								                  <span>
								                  	<span style={{lineHeight:'26px',cursor:'pointer',paddingBottom:'3px', borderBottom:'2px dotted #d5d5d5'}}>
																		<span>{this.processStyledText(ddict[e][1][1][0])}</span>
																		{ddict[e][1][2].map((key)=>
																			(key.value == e ? 
																		    <span style={{fontWeight:(this.state.boldedsubject ? '500' : '400')}}>{this.processStyledText(' '+key.text+' ')}</span>
																		    :
																		    null
																		  )
																		)}
								                  	<span>{this.processStyledText(ddict[e][1][1][1])}</span>
																		{ddict[e][1][3].map((key)=>
																			(key.value == e ? 
																		    <span style={{fontWeight:(this.state.boldedsubject ? '500' : '400')}}>{this.processStyledText(' '+key.text+(ddict[e][1][1][2].length > 0 ? ' ':''))}</span>
																		    :
																		    null
																		  )
																		)}
																		<span>{this.processStyledText(ddict[e][1][1][2])}</span>
																		</span>
								                  </span>
								                  :
																	(ddict[e][2].length > 0 ?
																		<span>{this.boldSubjects(ddict[e][2].join(', '))}</span>
																		:
																		null
																	)
								                } />
																:
																(ddict[e][1].length > 0 ?
																	<div>
																	<span>{this.processStyledText(ddict[e][1][1][0])}</span>
																	{ddict[e][1][2].map((key)=>
																		(key.value == e ? 
																	    <span style={{fontWeight:(this.state.boldedsubject ? '500' : '400')}}>{this.processStyledText(' '+key.text+' ')}</span>
																	    :
																	    null
																	  )
																	)}
																	<span>{this.processStyledText(ddict[e][1][1][1])}</span>
																	{ddict[e][1][3].map((key)=>
																		(key.value == e ? 
																	    <span style={{fontWeight:(this.state.boldedsubject ? '500' : '400')}}>{this.processStyledText(' '+key.text+(ddict[e][1][1][2].length > 0 ? ' ':''))}</span>
																	    :
																	    null
																	  )
																	)}
																	<span>{this.processStyledText(ddict[e][1][1][2])}</span>
																	{window.innerWidth >= innerWidthSetting && ddict[e][2].length > 0 ?
																		<span>{'; '+ddict[e][2].join('; ')}</span>
																		:
																		null
																	}
																	</div>
																	:
																	(ddict[e][2].length > 0 ?
																		<span>{this.boldSubjects(ddict[e][2].join(', '))}</span>
																		:
																		null
																	)
																)
															}
														</div>
														:
														null
														}
													</div>
													:
													null
													)
												)}
											</div>
										:
											<div style={{marginTop:'10px',paddingBottom:'12px'}}>
												<div style={{textAlign:'center',marginBottom:'20px'}}>
													{this.returnNonLinguisticTerm(d,'bottom')}
												</div>
												<div style={{marginLeft:(window.innerWidth < 480 ? '14px':'28px'),fontSize:'18px',fontWeight:400,color:'#b4b4b4',paddingTop:'5px',paddingBottom:'15px'}}>{this.state.verb_paradigms_processed[d][1]}</div>
											</div>
										)}
									}
								))
								:
								(moodList.map((d,ind) => // DROPDOWN
									{
										let sentenceCount = -1
										if (d in this.state.verb_paradigms_processed) {
										let dkey = this.state.verb_paradigms_processed[d][1][this.retrieveMoodKey(d)]
										if (dkey == undefined) {
											dkey = this.state.verb_paradigms_processed[d][1][Object.keys(this.state.verb_paradigms_processed[d][1])[0]]
										}
										return (this.state.verb_paradigms_processed[d][0] != 'DNE' && this.retrieveMoodKey(d) != 'DNE' ?
											(Object.keys(this.state.verb_paradigms_processed[d][1]).length > 1 && d != 'hortative' && d != 'imperative' && d != 'prohibitive' && d != 'imperfective_prohibitive' && d != 'imperfective_attributive' ?
												<div style={{marginTop:'18px'}}>
													<div style={{display:'flex',flexDirection:'row',marginTop:'15px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'5px',justifyContent:'space-between'}}>
														<div style={{display:'flex',flexDirection:(window.innerWidth < 480 ? 'column':'row'),fontSize:'20px',lineHeight:'34px'}}>
															{dkey[0].map((e,eindex)=>
																<span style={{display:'flex'}}>
																{e[1] == 'g' ?
		                              <Popup hideOnScroll on='click' position='center' content={
		                                <span style={{fontFamily:customFontFam, fontSize:'14px'}}>
		                                  <span>{'computer generated'}</span>
		                                </span>
		                              } trigger={
		                              	<span style={{cursor:'pointer'}}>
		                              	<span style={{color:"#646464"}}>{e[0]}</span>
		                              	<Image style={{marginLeft:'3px',marginBottom:'12px',height:'14px',opacity:'0.4', display:'inline'}} src={'ai1.jpg'}/>
		                              	</span>
		                              } />
		                              :
	                              	(e[1] == 'd' ?
																	<span style={{fontWeight:400,color:'#b4b4b4',fontSize:'18px'}}>{e[0]}</span>
	                              	:
	                              	<span>{e[0]}</span>
	                              	)
		                            }


															{this.state.disableRecord ?
																(e[2] != null && e[2].length > 0 ?
																	<div><Icon circular onClick={()=>this.repeatAudio(e[2][0]['filename'])} style={{marginLeft:'8px',fontSize:'14px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' /></div>
																	:
																	null
																)
																:
																<span>

										            {e[2] != null && !this.state.disableRecord ?
										              this.displayAudioMic(e[2],'m'+ind.toString()+'-'+eindex.toString())
										              :
										              null
										            }

										            {this.state.showModal != -1 ?
										              this.recordClip('m'+ind.toString()+'-'+eindex.toString(),e[0],'entryUsage6',dkey[3])
										              :
										              null
										            }
										          	</span>
															}



																{dkey[0].length > eindex+1 ?
																	<span style={{marginRight:'6px',marginLeft:'1px',color:'#3a3a3a'}}>{', '}</span>
																	:
																	null
																}				
																</span>
																)}
														</div>
														<div style={{textAlign:'right',lineHeight:'27px'}}>{this.returnNonLinguisticTerm(d)}</div>
													</div>
													<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>

													{dkey[1].length > 0 ?
														<span>
															<span>{this.processStyledText(dkey[1][1][0])}</span>
															{dkey[1][2].length == 1 ?
																<span style={{margin:'0px 4px'}}>{this.processStyledText(this.retrieveText(dkey[1][2],this.retrieveMoodKey(d)))}</span>
																:
																<Dropdown inline scrolling style={{border:'solid 1px #8e8e8e26',color:'#777777',fontSize:'16px',padding:'5px',borderRadius:'5px',margin:'0 4px',marginLeft:(dkey[1][1][0].length > 0 ? '4px':'0px')}} onChange={this.newMoodKey.bind(this, d)}  value={this.retrieveMoodKey(d)} options={dkey[1][2]} />
															}														

															{window.innerWidth < innerWidthSetting && dkey[2].length > 0 ?
								                <Popup hideOnScroll on='click' position='bottom right' content={
																	<div style={{fontSize:'16px'}}>
																		<div>
																		<div style={{textAlign:'center',fontStyle:'italic',color:'#aeaeae'}}>Also:</div>
																		<div style={{color:'#777777',margin:3}}>{dkey[2].join(', ')}</div>
																		</div>
																	</div>
								                } trigger={
								                  <span style={{cursor:'pointer',paddingBottom:'3px', borderBottom:'2px dotted #d5d5d5'}}>
								                  	{this.processStyledText(dkey[1][1][1])}
								                  </span>
								                } />
																:
																<span>{this.processStyledText(dkey[1][1][1])}</span>
															}

															{dkey[1][3].length > 0 ? 
																(dkey[1][3].length == 1 ?
																	<span style={{margin:'0px 4px'}}>{this.processStyledText(this.retrieveText(dkey[1][3],this.retrieveMoodKey(d)))}</span>
																	:
																	<Dropdown inline scrolling style={{border:'solid 1px #8e8e8e26',color:'#777777',fontSize:'16px',padding:'5px',borderRadius:'5px',margin:'0px 4px'}} onChange={this.newMoodKey.bind(this, d)}  value={this.retrieveMoodKey(d)} options={dkey[1][3]} />
																)
																:
																null
															}
															<span>{this.processStyledText(dkey[1][1][2])}</span>
														</span>
														:
														null
													}

														{dkey[2].length > 0 && window.innerWidth >= innerWidthSetting  ?
															<span>{'; '+dkey[2].join('; ')}</span>
															:
															null
														}
													</div>
												</div>
											:
													(this.state.POSCandidateList.map((newkey, newkeyind)=>{
														if (newkey in this.state.verb_paradigms_processed[d][1]) {
														sentenceCount = sentenceCount+1
														dkey = this.state.verb_paradigms_processed[d][1][newkey]
														return <div style={{marginTop:'18px'}}>
															<div style={{display:'flex',flexDirection:'row',marginTop:'15px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'5px',justifyContent:'space-between'}}>
																<div style={{display:'flex',flexDirection:(window.innerWidth < 480 ? 'column':'row'),fontSize:'20px',lineHeight:'34px'}}>
																	{dkey[0].map((e,eindex)=>
																		<span style={{display:'flex'}}>
																		{e[1] == 'g' ?
				                              <Popup hideOnScroll on='click' position='center' content={
				                                <span style={{fontFamily:customFontFam, fontSize:'14px'}}>
				                                  <span>{'computer generated'}</span>
				                                </span>
				                              } trigger={
				                              	<span style={{display:'flex',cursor:'pointer'}}>
				                              	<span style={{color:"#646464"}}>{e[0]}</span>
				                              	<Image style={{marginLeft:'3px',cursor:'pointer',height:'14px',opacity:'0.4', display:'inline'}} src={'ai1.jpg'}/>
				                              	</span>
				                              } />
				                              :
			                              	(e[1] == 'd' ?
																			<span style={{fontWeight:400,color:'#b4b4b4',fontSize:'18px'}}>{e[0]}</span>
			                              	:
			                              	<span>{e[0]}</span>
			                              	)
				                            }


																		{this.state.disableRecord ?
																			(e[2] != null && e[2].length > 0 ?
																				<div><Icon circular onClick={()=>this.repeatAudio(e[2][0]['filename'])} style={{marginLeft:'8px',fontSize:'14px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' /></div>
																				:
																				null
																			)
																			:
																			<span>
													            {e[2] != null && !this.state.disableRecord ?
													              this.displayAudioMic(e[2],'o'+ind.toString()+'-'+newkeyind.toString())
													              :
													              null
													            }

													            {this.state.showModal != -1 ?
													              this.recordClip('o'+ind.toString()+'-'+newkeyind.toString(),e[0],'entryUsage7',dkey[3])
													              :
													              null
													            }
													          	</span>
																		}

																		{dkey[0].length > eindex+1 ?
																			<span style={{marginRight:'6px',marginLeft:'1px',color:'#3a3a3a'}}>{', '}</span>
																			:
																			null
																		}				
																		</span>
																		)}
																</div>
																{sentenceCount == 0 ? <div style={{textAlign:'right',lineHeight:'27px'}}>{this.returnNonLinguisticTerm(d)}</div> : null}
															</div>
															{dkey[1].length > 0 ?
																<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>
																	<span>{this.processStyledText(dkey[1][1][0])}</span>
																	<span style={{margin:'0px 4px',marginLeft:(dkey[1][1][0].length > 0 ? '4px':'0px')}}>{this.processStyledText(this.retrieveText(dkey[1][2],newkey))}</span>
																	<span>{this.processStyledText(dkey[1][1][1])}</span>

																	{dkey[1][3].length > 0 ? 
																		<span style={{margin:'0px 4px'}}>{this.processStyledText(this.retrieveText(dkey[1][3],newkey))}</span>
																		:
																		null
																	}
																	<span>{this.processStyledText(dkey[1][1][2])}</span>
																	{dkey[2].length > 0 ?
																		<span>{'; '+dkey[2].join(', ')}</span>
																		:
																		null
																	}
																</div>
																:
																<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>
																	{dkey[2].length > 0 ?
																		dkey[2].join(', ')
																		:
																		null
																	}
																</div>																
															}
														</div>
														}
													}))
											)
										:
														<div style={{marginTop:'18px'}}>
															<div style={{display:'flex',flexDirection:'row',marginTop:'17px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'17px',justifyContent:'space-between'}}>
																<div style={{display:'flex',flexDirection:(window.innerWidth < 480 ? 'column':'row'),fontSize:'20px',lineHeight:'34px'}}>
																	<div style={{fontSize:'18px',fontWeight:400,color:'#b4b4b4',paddingTop:'7px',paddingBottom:'10px'}}>{this.state.verb_paradigms_processed[d][1]}</div>
																</div>
																<div style={{textAlign:'right',lineHeight:'27px'}}>{this.returnNonLinguisticTerm(d)}</div>
															</div>
														</div>
										)}
									}
								))
							}

						</div>
						:
						null
					}


					{this.state.children.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Children</span>
							</div>
							<List style={{marginTop:0}} divided>
							{this.state.children.map((key, index) =>
								{
								let word = key
						    return <List.Item style={{padding:7,paddingTop:11,paddingBottom:11}} key={word.url}>
						    <Link to={{pathname: '/' + word.url}} onClick={()=>{this.setState({key:word.url, from: this.props.location.pathname})}}>
                  <List.Content floated='right'>
                    <Icon circular style={{marginTop:'2px', color:'#8f8f8f'}} name='chevron right' />
                  </List.Content>
						    </Link>
						      <List.Content  style={{paddingRight:'16px'}}>
						        <List.Header style={{fontSize:'16px',paddingBottom:'2px',fontFamily:customFontFam,lineHeight:'25px',paddingLeft:'15px'}}>
				          		<div style={{display:'flex',alignItems:'center'}}> 
                        <Link style={{color:'#306190'}} to={{pathname: '/' + word.url, state: { word: word.url, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  				              <span style={{'paddingRight':'3px',fontWeight:'500'}}> {/* ,borderBottom:'1px solid #858585',paddingBottom:'1px', */}
                          {this.processStyledTextLink(word.lexicon)}
                        </span>
                        </Link>

												{this.state.disableRecord ?
	                        (key.soundfile != null && key.soundfile.length != 0 ?
	                          <Icon circular onClick={()=>this.repeatAudio(word.soundfile[0]['filename'])} style={{marginLeft:'10px',fontSize:'13px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
	                          :
	                          null
	                        )
													:
													<span>
													{console.log(key)}
							            {key.soundfile != null && !this.state.disableRecord ?
							              this.displayAudioMic(key.soundfile,'e'+index.toString())
							              :
							              null
							            }

							            {this.state.showModal != -1 ?
							              this.recordClip('e'+index.toString(),key.lexicon,'entryUsage8',key.gloss.join('; '))
							              :
							              null
							            }
							          	</span>
												}


                        {'dialect' in word ?
                          (word.dialect.map((d,dindex)=>
                            <span style={{'marginLeft':(dindex == 0 ? '12px':'0px'),marginRight:'6px'}}>  
                              <span style={{display:'flex',marginRight:'5px'}}>
                                <TagColors homeMode={0} tags={d} width={window.innerWidth} />
                              </span>
                            </span>
                          ))
                          :
                          null
                        }
                        <span style={{'marginLeft':('dialect' in word ? '0px':'12px'),marginRight:'6px'}}>  
                          <span style={{display:'flex',marginRight:'5px'}}>
                            <TagColors homeMode={0} tags={word.pos} width={window.innerWidth} />
                          </span>
                        </span>

				              </div>
						        </List.Header>
						        <List.Description style={{fontSize:'16px',color:'#000000cc',paddingLeft:'15px',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{this.processStyledText(word.gloss.join('; '))}</List.Description>
						      </List.Content>
						    </List.Item>
              	})}
							</List>

						</div>
						:
						null
					}




					{Object.keys(this.state.verb_paradigms).length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Verb Paradigms</span>
							</div>
							{moodList.map((d,ind) =>
								(d in this.state.verb_paradigms ?
									(Object.keys(this.state.verb_paradigms[d]).map((e,eindex)=>
										<div style={{marginTop:'18px'}}>
											<div style={{display:'flex',marginTop:'15px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'5px',justifyContent:'space-between'}}>
												<div style={{fontSize:'20px',lineHeight:'34px'}}>
													{this.state.verb_paradigms[d][e][0].map((j,jindex)=>
															<span>
															<span style={{color:(j=='[does not occur]' || j.includes("ee '") ? '#b4b4b4':null)}}>
																{this.processStyledText(j)}
															</span>


																{this.state.disableRecord ?
																	(this.state.verb_paradigms[d][e][2][jindex] != null && this.state.verb_paradigms[d][e][2][jindex].length > 0 ?
																		<Icon circular onClick={()=>this.repeatAudio(this.state.verb_paradigms[d][e][2][jindex][0]['filename'])} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
																		:
																		null
																	)
																	:
																	<span>
											            {this.state.verb_paradigms[d][e][2][jindex] != null && !this.state.disableRecord ?
											              this.displayAudioMic(this.state.verb_paradigms[d][e][2][jindex],'q'+ind.toString()+'-'+eindex.toString())
											              :
											              null
											            }

											            {this.state.showModal != -1 ?
											              this.recordClip('q'+ind.toString()+'-'+eindex.toString(),this.state.verb_paradigms[d][e][0][jindex],'entryUsage9',this.state.verb_paradigms[d][e][1][jindex])
											              :
											              null
											            }
											          	</span>
																}


																{jindex !== this.state.verb_paradigms[d][e][0].length-1 ? ', ' : ''}
															</span>
														)}
												</div>
												{eindex == 0 ? <div style={{textAlign:'right',lineHeight:'27px'}}>{this.returnNonLinguisticTerm(d)}</div> : null}
											</div>
											<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>
												{this.state.verb_paradigms[d][e][1].map((j,jindex)=><span>{this.processStyledText(j)}{jindex !== this.state.verb_paradigms[d][e][1].length-1 ? ', ' : ''}</span>)}
											</div>
										</div>									
									))
									:
									null
								)
							)}
{/*

							{Object.keys(this.state.verb_paradigms).map((d,ind) => 
								(this.state.verb_paradigms[d][0][0] === '[does not occur]' ?
									<div style={{margin:'25px 0px'}}>
										<div style={{display:'flex',justifyContent:'center'}}>
											<div style={{fontSize:'16px',color:'#acacac',fontStyle:'italic'}}>
											{d in nonLinguistic ? 
												this.processStyledText(nonLinguistic[d] + ' does not occur')
												:
												this.processStyledText(d.replaceAll('_',' ')+' does not occur')
											}
											</div>

										</div>

									</div>
									:
									null
								)
								)}
*/}

						</div>
						:
						null
					}

					{this.state.siblings.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Siblings</span>
							</div>
							<List style={{marginTop:0}} divided>
							{this.state.siblings.map((key, index) =>
								{
								let word = key
						    return <List.Item style={{padding:7,paddingTop:11,paddingBottom:11}} key={word.url}>
						    <Link to={{pathname: '/' + word.url}} onClick={()=>{this.setState({key:word.url, from: this.props.location.pathname})}}>
                  <List.Content floated='right'>
                    <Icon circular style={{marginTop:'2px', color:'#8f8f8f'}} name='chevron right' />
                  </List.Content>
						    </Link>
						      <List.Content  style={{paddingRight:'16px'}}>
						        <List.Header style={{fontSize:'16px',paddingBottom:'2px',fontFamily:customFontFam,lineHeight:'25px',paddingLeft:'15px'}}>
				          		<div style={{display:'flex',alignItems:'center'}}> 
                        <Link style={{color:'#306190'}} to={{pathname: '/' + word.url, state: { word: word.url, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  				              <span style={{'paddingRight':'3px',fontWeight:'500'}}> {/* ,borderBottom:'1px solid #858585',paddingBottom:'1px', */}
                          {this.processStyledTextLink(word.lexicon)}
                        </span>
                        </Link>


												{this.state.disableRecord ?
	                        (key.soundfile != null && key.soundfile.length != 0 ?
	                          <Icon circular onClick={()=>this.repeatAudio(word.soundfile[0]['filename'])} style={{marginLeft:'10px',fontSize:'13px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
	                          :
	                          null
	                        )
													:
													<span>
							            {key.soundfile != null && !this.state.disableRecord ?
							              this.displayAudioMic(key.soundfile,'c'+index.toString())
							              :
							              null
							            }

							            {this.state.showModal != -1 ?
							              this.recordClip('c'+index.toString(),key.lexicon,'entryUsage10',key.gloss.join('; '))
							              :
							              null
							            }
							          	</span>
												}



                        {'dialect' in word ?
                          (word.dialect.map((d,dindex)=>
                            <span style={{'marginLeft':(dindex == 0 ? '12px':'0px'),marginRight:'6px'}}>  
                              <span style={{display:'flex',marginRight:'5px'}}>
                                <TagColors homeMode={0} tags={d} width={window.innerWidth} />
                              </span>
                            </span>
                          ))
                          :
                          null
                        }
                        <span style={{'marginLeft':('dialect' in word ? '0px':'12px'),marginRight:'6px'}}>  
                          <span style={{display:'flex',marginRight:'5px'}}>
                            <TagColors homeMode={0} tags={word.pos} width={window.innerWidth} />
                          </span>
                        </span>

				              </div>
						        </List.Header>
						        <List.Description style={{fontSize:'16px',color:'#000000cc',paddingLeft:'15px',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{this.processStyledText(word.gloss.join('; '))}</List.Description>
						      </List.Content>
						    </List.Item>
              	})}
							</List>

						</div>
						:
						null
					}

					{this.state.homonyms.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Homonyms</span>
							</div>
							<List style={{marginTop:0}} divided>
							{this.state.homonyms.map((key, index) =>
								{
								let word = key
						    return <List.Item style={{padding:7,paddingTop:11,paddingBottom:11}} key={word.url}>
						    <Link to={{pathname: '/' + word.url}} onClick={()=>{this.setState({key:word.url, from: this.props.location.pathname})}}>
                  <List.Content floated='right'>
                    <Icon circular style={{marginTop:'2px', color:'#8f8f8f'}} name='chevron right' />
                  </List.Content>
						    </Link>
						      <List.Content  style={{paddingRight:'16px'}}>
						        <List.Header style={{fontSize:'16px',paddingBottom:'2px',fontFamily:customFontFam,lineHeight:'25px',paddingLeft:'15px'}}>
				          		<div style={{display:'flex',alignItems:'center'}}> 
                        <Link style={{color:'#306190'}} to={{pathname: '/' + word.url, state: { word: word.url, from: this.props.location.pathname, history:[this.state.search,this.state.wordsList, this.state.Yposition, this.state.activeTabIndex] }}}>
  				              <span style={{'paddingRight':'3px',fontWeight:'500'}}> {/* ,borderBottom:'1px solid #858585',paddingBottom:'1px', */}
                          {this.processStyledTextLink(word.lexicon)}
                        </span>
                        </Link>


												{this.state.disableRecord ?
	                        (key.soundfile != null && key.soundfile.length != 0 ?
	                          <Icon circular onClick={()=>this.repeatAudio(word.soundfile[0]['filename'])} style={{marginLeft:'10px',fontSize:'13px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
	                          :
	                          null
	                        )
													:
													<span>
							            {key.soundfile != null && !this.state.disableRecord ?
							              this.displayAudioMic(key.soundfile,'d'+index.toString())
							              :
							              null
							            }

							            {this.state.showModal != -1 ?
							              this.recordClip('d'+index.toString(),key.lexicon,'entryUsage11',key.gloss.join('; '))
							              :
							              null
							            }
							          	</span>
												}

                        {'dialect' in word ?
                          (word.dialect.map((d,dindex)=>
                            <span style={{'marginLeft':(dindex == 0 ? '12px':'0px'),marginRight:'6px'}}>  
                              <span style={{display:'flex',marginRight:'5px'}}>
                                <TagColors homeMode={0} tags={d} width={window.innerWidth} />
                              </span>
                            </span>
                          ))
                          :
                          null
                        }
                        <span style={{'marginLeft':('dialect' in word ? '0px':'12px'),marginRight:'6px'}}>  
                          <span style={{display:'flex',marginRight:'5px'}}>
                            <TagColors homeMode={0} tags={word.pos} width={window.innerWidth} />
                          </span>
                        </span>

				              </div>
						        </List.Header>
						        <List.Description style={{fontSize:'16px',color:'#000000cc',paddingLeft:'15px',fontWeight:'400',lineHeight:'23px',paddingTop:'4px'}}>{this.processStyledText(word.gloss.join('; '))}</List.Description>
						      </List.Content>
						    </List.Item>
              	})}
							</List>

						</div>
						:
						null
					}



					{this.state.Verb_Root.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Verb Root</span>
							</div>
							<div style={{marginTop:'18px',marginBottom:'18px'}}>
								<div style={{marginBottom:'10px'}}>
								<Link to={{pathname: '/' + this.state.Verb_Root, state: { word: this.state.Verb_Root, from: this.props.location.pathname }}}><span className='extrainformation'  style={{borderBottom:'1px solid #306190',paddingBottom:'1px',color:'#306190'}}>{this.state.Verb_Root}</span></Link>
								</div>
							</div>
						</div>
						:
						null
					}
					



					{this.state.semantic_domain.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Category List</span>
							</div>
							<div style={{marginTop:'18px',marginBottom:'18px'}}>
							{this.state.semantic_domain.map((d) => 
								<div style={{marginBottom:'10px'}}>
								<Link to={{pathname: '/', state: { currentCategory: d.split(' ')[0], homeMode:3 }}}><span className='extrainformation'  style={{borderBottom:'1px solid #306190',paddingBottom:'1px',color:'#306190'}}>{d.split(' ').slice(1).join(' ')}</span></Link>
								</div>
							)}
							</div>
						</div>
						:
						null
					}




					{this.state.reversal.length !== 0 && false?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>English Lookup</span>
							</div>
							{this.state.reversal.map((d) => 
								<div style={{marginTop:'18px',marginBottom:'18px'}} className='extrainformation'>{this.processStyledText(d)}</div>
							)}
						</div>
						:
						null
					}





					{this.state.noun_paradigms.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Noun Paradigms</span>
							</div>

							{this.state.noun_paradigms.map((d,ind) =>
									<div style={{marginTop:'18px'}}>
										<div style={{display:'flex',marginTop:'15px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'5px',justifyContent:'space-between'}}>
											<div style={{fontSize:'20px',lineHeight:'34px'}}>
												{d[1][0].map((j,jindex)=>
													<span style={{color:(j=='[does not occur]' ? '#b4b4b4':null)}}>
													{this.processStyledText(j)}

													{this.state.disableRecord ?
														(d[1][2][jindex] != null && d[1][2][jindex].length > 0 ?
															<Icon circular onClick={()=>this.repeatAudio(d[1][2][jindex][0]['filename'])} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
															:
															null
														)
														:
														<span>
								            {d[1][2][jindex] != null && !this.state.disableRecord ?
								              this.displayAudioMic(d[1][2][jindex],'x'+ind.toString()+'-'+jindex.toString())
								              :
								              null
								            }

								            {this.state.showModal != -1 ?
								              this.recordClip('x'+ind.toString()+'-'+jindex.toString(),d[1][0].join('; '),'entryUsage12',d[1][1].join('; '))
								              :
								              null
								            }
								          	</span>
													}


													{jindex !== d[1][0].length-1 ? ', ' : ''}
														</span>)}
											</div>
											{this.returnNonLinguisticTerm(d[0])}
										</div>
										<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>
											{d[1][1].map((j,jindex)=><span>{this.processStyledText(j)}{jindex !== d[1][1].length-1 ? ', ' : ''}</span>)}
										</div>
									</div>									
							)}
						</div>
						:
						null
					}

					{this.state.adverb_paradigms.length !== 0 ?
						<div>
							<div className='hierarchymain'>
							<span className='span1'></span>
							<span className='span2' style={{marginLeft:(window.innerWidth < innerWidthSetting ? '8px':'10px')}}>Adverb Paradigms</span>
							</div>

							{this.state.adverb_paradigms.map((d,ind) =>
									<div style={{marginTop:'18px',marginBottom:'18px'}}>
										<div style={{display:'flex',marginTop:'15px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),marginBottom:'5px',justifyContent:'space-between'}}>
											<div style={{fontSize:'20px',lineHeight:'34px'}}>
												{d[1].map((j,jindex)=>
													<span style={{color:(j=='[does not occur]' ? '#b4b4b4':null)}}>
													{this.processStyledText(j)}


													{this.state.disableRecord ?
														(d[2][jindex].length > 0 ?
															<Icon circular onClick={()=>this.repeatAudio(d[2][jindex][0]['filename'])} style={{marginLeft:'12px',fontSize:'16px',color:'#8F8F8F',cursor:'pointer'}} name='volume up' />
															:
															null
														)
														:
														<span>
								            {d[2][jindex] != null && !this.state.disableRecord ?
								              this.displayAudioMic(d[2][jindex],'v'+ind.toString()+'-'+jindex.toString())
								              :
								              null
								            }

								            {this.state.showModal != -1 ?
								              this.recordClip('v'+ind.toString()+'-'+jindex.toString(),d[1].join('; '),'entryUsage13','')
								              :
								              null
								            }
								          	</span>
													}


													{jindex !== d[1].length-1 ? ', ' : ''}
													</span>)}
											</div>
											{this.returnNonLinguisticTerm(d[0])}
										</div>
										{/*<div style={{marginBottom:'18px',marginRight:(window.innerWidth < innerWidthSetting ? '9px':'2px'), marginLeft:(window.innerWidth < innerWidthSetting ? '20px':'22px'),fontSize:'16px',color:'#777777'}}>
											{d[1][1].map((j,jindex)=><span>{console.log(j)}{this.processStyledText(j)}{jindex !== d[1][1].length-1 ? ', ' : ''}</span>)}
										</div>*/}
									</div>									
							)}
						</div>
						:
						null
					}


				</div>

					<div style={{paddingTop:'10px',paddingBottom:'30px',paddingLeft:'8px'}}>
			    <Link to={{pathname: '/report'}}>
						<Icon style={{color:'#a9a9a9',}} name='exclamation circle' />
						<span style={{fontSize:'14px',color:'#9d9d9d',fontWeight:'400',lineHeight:'23px'}}>Report an Issue</span>
          </Link>

          <div style={{color:'#a9a9a9',display:'flex',alignItems:'center',marginTop:'10px'}}>If you are a Tlingit speaker, you may use recording mode. <Checkbox style={{marginLeft:5}} onClick={()=>{this.setState({disableRecord:!this.state.disableRecord})}} checked={!this.state.disableRecord} toggle /></div>
					</div>


				</Grid.Column>
				</Grid.Row>
				</Grid>
				</Transition>
			</div>
		);
	}
}
export default Entry;